module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-uniforme-personalizado.c44d3378.jpg";